import { ModuleService } from 'src/app/services/modules/module.service';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FileUpload } from 'src/app/model/file';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';



import Swal from 'sweetalert2'

import { EmailServiceComponent } from 'src/app/services/mail/email.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { AnnotationLayerRenderedEvent } from 'ngx-extended-pdf-viewer';
import { PdfComponent } from '../../common/pdf/pdf.component';
import { Level } from 'src/app/interfaces/academic-years';
import { NavigationStateService } from 'src/app/services/navigation/navigation.service';
declare let Email: any;
const ZOOM_STEP: number = 0.25;
const DEFAULT_ZOOM: number = 1;

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit, OnDestroy {

  @ViewChild('file1', { static: false }) fileOne: any;
  @ViewChild('file2', { static: false }) attachment: any;
  @ViewChild('file3', { static: false }) attachmentPdf: any;
  public isChangedItems = false;


  @ViewChild("update", { read: ElementRef, static: true }) target1ref: ElementRef;
  @ViewChild("pdf", { read: ElementRef, static: true }) pdf: ElementRef;
  p: Number = 1;
  count: Number = 4;
  @ViewChild('tooltip') tooltip: NgbTooltip;
  public pdfZoom: number = DEFAULT_ZOOM;
  public selectedFiles?: FileList;
  public selectedFilesPdf?: FileList;
  public spinner = false;
  public currentFileUpload?: FileUpload;
  public currentFileUploadPdf?: FileUpload;
  public error;
  public spinnerShare: Boolean = false;
  public spinnerTable = true;
  public message;
  public downloadmessage;
  public extension = "pptx";
  public percentage: number = 0;
  public title: string;
  public level: string;
  public selectedCheckboxItemsList = [];
  isSameNameFile = false;
  elementsToShare: any[] = [];
  elementsToShareAll = {}; //not used?
  coursesUnlocked: { id: String, unlocked: Boolean, year: String, level: String }[] = [];
  downloadError;
  number;
  downloadMessage;
  isWord = false;
  public mods = {};
  public items: Level[] = [];
  elementSelected: any;
  hide = true;
  hidePdf = true;
  courses: string //not used?;
  pdfSrc: String;
  showSpinnerPdf: boolean;
  errorForm: any;
  messageForm: any;
  spinnerForm = false;
  public year: string;
  public courseAlreadyShared: boolean;
  moduleByLevel: any;
  newItems: { id: String; docId: String; unlocked: Boolean; date?: String; notice?: String; step?: String; }[];

  constructor(public stateService: NavigationStateService, public config: NgbModalConfig, private modalService: NgbModal, public module: ModuleService, public router: Router, public modules: ModuleService, public email: EmailServiceComponent) {

    config.backdrop = 'static';
    config.keyboard = false;
    this.moduleByLevel = this.stateService.getState("courses");
    if (this.router.getCurrentNavigation()
      && this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
      this.title = this.router.getCurrentNavigation().extras.state.title;
      this.number = this.router.getCurrentNavigation().extras.state.level;
      this.year = this.router.getCurrentNavigation().extras.state.year;
      this.level = "level" + this.number;
      localStorage.setItem("data", JSON.stringify({ level: this.level, title: this.title, number: this.number }));

    }
    else {
      const data = history.state;
      this.title = data.title;
      this.number = data.number;
      this.level = data.level;
      this.year = data.year;
    }


    this.isWord = this.level == 'level3' || this.level == 'level4';
    this.downloadmessage = this.defaulMessage();

    this.getCourses();
    this.modules.subject.subscribe({
      next: (value: number) => this.percentage = value
    });

    this.modules.uploadFinish.subscribe({
      next: (x: boolean) => {
        if (x) {
          this.spinnerForm = false;
          this.init("", "Les fichiers ont été mis à jour avec succès.", this.currentFileUpload, true);
          this.email.sendNotificationMailUpdatedCourse(this.elementSelected.id).then(x => {
            this.messageForm = this.messageForm + " Un mail de notification a été envoyé à centreformationapostolique@gmail.com"
            this.init("", this.messageForm, this.currentFileUpload, true);

          });

        }
        else {
          this.spinnerForm = false;
          this.init("Un problème technique s'est produit, veuillez contacter l'administrateur du site.", "", this.currentFileUpload, true);
          this.currentFileUpload = null;

        }
        this.elementSelected["showSpinner"] = false;
      }
    });
  }

  public tooltipPopUp() {
    this.tooltip.close()
    this.tooltip.ngbTooltip = "Cocher ou décocher le(s) checbox présent(s) sur chaque ligne de cours et cliquer sur le bouton partager...";
    this.tooltip.open();
  }

  private defaulMessage(): string {
    let name = this.isWord ? "word" : "power point";
    return `Importer le fichier ${name} et le fichier pdf associé que vous avez mis à jour.`;
  }

  public hidePdfLoading() {
    this.showSpinnerPdf = false;
  }

  /**
   * 
   * @param content 
   */
  open(content) {
    this.modalService.open(content);
  }

  /**
   * Retrieve all courses about the level class
   */
  private getCourses(): void {
    this.items = [];
    //this.modules.modules();

    this.modules.getModule(
      this.level).subscribe((levels: Level[]) => {
        this.items = levels;
        this.items = this.items.sort((a, b) => a['index'] - b['index']);
        this.newItems = this.items.map(item => ({ ...item }));

        this.spinnerTable = false;
        //this.elementsToShare = this.fetch();
        //this.coursesUnlocked = this.fetch(true);
        this.courseAlreadyShared = this.elementsToShare.length >= 1 ? true : false;
      }, error => {
        console.log(error);
      })
  }


  ngOnInit(): void {

  }

  ngOnDestroy() {

  }

  /**
   *  Enable or disable a course to see by a student class
   */
  public share() {

    console.log(this.elementsToShare)
    let courses = this.elementsToShare.map((item:any) => {
      return { id: item.docId, unlocked: item.unlocked ? true : false, year: this.year, level: this.level }});
     //this.spinnerShare = true;
    console.log(courses)


     this.modules.updateStatusCourse(courses)
      .then(x => {
        if (this.elementsToShare.length == 0) {
          this.init("", "Tous les cours ne seront plus visible dans l'espace personnel de vos Etudiants.", this.currentFileUpload);
          this.courseAlreadyShared = false;

        }
        else {
          this.init("", "Les cours sélectionnés seront visibles dans l'espace personnel de vos Etudiants.", this.currentFileUpload);
          this.getCourses();  
          this.isChangedItems = false;
          this.elementsToShare = [];
        }

        this.selectedCheckboxItemsList = [];
        this.spinnerShare = false;


      }, (error) => {
        this.selectedCheckboxItemsList = [];
        this.spinnerShare = false;
      })
  }

  /**
 * 
 * @param elmt 
 * @returns 
 */
  public isSelected(elmt: any) {
    return elmt.selected;
  }

  /**
  *  Selece a course
  * 
  * @param item 
  */
  public selectItem(item) {
    if (this.elementSelected) {
      this.elementSelected["selected"] = false;
      if (!this.elementSelected["showSpinner"]) {
        this.elementSelected["showSpinner"] = false;
      }

    }
    item["selected"] = true;
    this.elementSelected = item;
  }

  /**
  * select file excel/pdf for updating
  */
  public selectFile(event: any): void {
    this.init("", "");
    this.selectedFiles = event.target.files;
  }

  private checkFileName(file, filePdf) {

    if (this.removeExtention(filePdf.name, "pdf") !=
      this.removeExtention(file.name, "pptx")) {
      this.init("Les noms des fichiers ne correspondent pas.", "", "", true);
      this.spinnerForm = false;
      return false;
    }
    return true

  }

  /**
  * select file excel/pdf for updating
  */
  public selectFilePdf(event: any): void {
    this.init("", "");
    this.selectedFilesPdf = event.target.files;
  }

  /**
  * 
  * @param check  if true = the elements are selected and false if not
  * @returns 
  */
  private fetch(islocked = false) {
    return this.items.filter((item: Level) => {
      return item['hasChanged'];
    }).map(item => {
      return { id: item.docId, unlocked: islocked ? false : item.unlocked, year: this.year, level: this.level }
    })
  }

  private hasItemsChanged(itemSelected): void {

    const oldItem: any = this.newItems.filter(oldItem => oldItem.id == itemSelected.id);

    if (oldItem[0].unlocked !== itemSelected.unlocked) {
      this.elementsToShare.push(itemSelected);
    }
    else {
      const index = this.elementsToShare.findIndex(item => item.id === itemSelected.id);
      if (index > -1) {
        this.elementsToShare.splice(index, 1);
      }

    }
     this.isChangedItems  = this.elementsToShare.length?true:false;
  }

  /**
   *  Save the courses selected
   */
  public changeSelection(item) {
    this.init("", "");

    this.hasItemsChanged(item);
    // this.elementsToShare = this.fetch();
  }

  public onEvent(event: AnnotationLayerRenderedEvent): void {
    (event.source as any).div.querySelectorAll("input").forEach(x => x.disabled = true);
  }


  /**
   * 
   * @param item 
   */
  private updateCC(item) {
    this.init("", "", "", true);
    this.hide = false;

    if (this.attachment) {
      this.attachment.nativeElement.value = null;
    }

    if (this.attachmentPdf) {
      this.attachmentPdf.nativeElement.value = null;
    }
    if (this.fileOne) {
      this.fileOne.nativeElement.value = null;
    }

    this.spinnerForm = false
    this.selectedFiles = null;
    this.selectItem(item);
    Swal.fire({
      showCloseButton: true,
      customClass: 'swal-wide',
      focusConfirm: false,
      showConfirmButton: false,
      html: this.target1ref.nativeElement,
    }).then((result) => {


    })
  }


  /**
   * 
   * @returns 
   */
  public submitUpdate() {
    this.spinnerForm = true;
    if (this.selectedFilesPdf == null || this.selectedFiles == null) {
      this.init("Il est obligatoire de joindre les fichiers demandés pour mettre à jour le cours", "", "", true);
      this.spinnerForm = false;
      return;

    }
    let file: File | null = this.selectedFiles.item(0);;
    let filePdf: File | null = this.selectedFilesPdf.item(0);;

    if (this.checkFileName(file, filePdf) && this.check(file)) {

      this.upload(file, filePdf);
    }
  }

  check(file) {
    if (this.elementSelected.id != this.removeExtention(file.name, "pptx")) {
      this.init(`importer les fichiers qui ont le même nom du fichier du cours selectionné. Le nom du fichier attendu est: ${this.elementSelected.id}`, "", "", true);
      this.spinnerForm = false;
      return false;
    }
    return true;
  }

  /**
   * Upload the file
   */
  private upload(file, filePdf): void {

    this.elementSelected["showSpinner"] = true;

    const found = this.items.find((element) => {
      return element.id == this.removeExtention(file.name, "pptx");
    });

    if (found) {
      this.currentFileUpload = new FileUpload(file);
      this.currentFileUploadPdf = new FileUpload(filePdf);
      this.modules.pushFileToStorage(this.level, this.currentFileUploadPdf, this.currentFileUpload);
      this.selectedFiles = undefined;
    }
    else {
      this.spinnerForm = false;
      this.init("Le nom du fichier ne correspond pas à la liste des cours répertoriés.", "", "", true);
    }

  }

  /**
   * 
   * @param error 
   * @param message 
   * @param currentFileUpload 
   * @param isForm 
   */
  private init(error, message, currentFileUpload = null, isForm?: boolean) {
    this.currentFileUpload = currentFileUpload;
    if (isForm) {
      this.errorForm = error;
      this.messageForm = message;
      this.error = "";
      this.message = "";
    }
    else {
      this.error = error;
      this.message = message;
    }
  }

  /**
 *  Open the pdf 
 * 
 * @param item 
 */
  public async pop(item, content) {
    let data = {};
    data["level"] = this.level;
    data["id"] = item.id;
    this.pdfSrc = await this.module.getUrlPdf(data);
    this.router.navigateByUrl(`/pdf`, { state: { title: item.id?.split('-')[1], url: this.pdfSrc, level: this.number } });
  }


  /**
   * ZOOM pdf +
  */
  public zoomIn() {
    this.pdfZoom += ZOOM_STEP;
  }


  /**
   * ZOOM pdf -
  */
  public zoomOut() {
    if (this.pdfZoom > DEFAULT_ZOOM) {
      this.pdfZoom -= ZOOM_STEP;
    }
  }

  /**
   * 
   * @param name 
   * @param extension 
   * @returns 
   */
  private removeExtentions(name: string) {
    let f = name.replace(`.pptx`, "");
    f = f.replace(`.docx`, "");
    f = f.replace(`.doc`, "");
    return f;
  }

  /**
   * Upload the file
   */
  public download(item: string): void {
    this.modules.downloadFile(this.level, item, this.isWord);
  }



  /**
   * 
   * @param name 
   * @param extension 
   * @returns 
   */
  private removeExtention(name: string, extension: string) {
    let nameFile = name.replace(`.${extension}`, "");

    if (this.isWord) {
      nameFile = nameFile.replace(`.docx`, "");
      nameFile = nameFile.replace(`.doc`, "");
    }
    return nameFile;
  }
}
